'use client';
import { classNames } from '@repo/ui/src/utils/classNames';
import CheckIcon from '@repo/ui/src/components/Icons/CheckIcon';
import Button, { ButtonVariant } from '@repo/ui/src/components/Button';
import BaseAccordion from '../../components/BaseAccordion';

import type { MouseEvent } from 'react';

interface FilterOption {
  title: string;
  filter: string;
  count?: number;
}

interface FilterGroup {
  title: string;
  filterType: string;
  options: Array<FilterOption>;
}

interface FilterAccordionProps {
  currentFilters?: Record<string, Array<string>>;
  setFilters: (selection: { filterType: string; filterName: string }) => void;
  filter?: FilterGroup;
}

const FilterAccordion = ({
  currentFilters,
  setFilters,
  filter: { options, filterType, title } = {} as FilterGroup,
}: FilterAccordionProps) => {
  const filters = currentFilters?.[filterType] ?? [];
  const isOpen = !!filters.length;
  return (
    <BaseAccordion
      title={title}
      titleVariant="h3"
      titleClassName="tra-text-web-sub-3"
      className="[&_before]:!bg-white"
      isOpen={isOpen}
      controlled={isOpen}
    >
      <ul className="list-none p-0">
        {options?.map((series, index) => {
          const isActive =
            currentFilters &&
            currentFilters[filterType] &&
            currentFilters[filterType].includes(series.filter);
          return (
            <li className="mb-2" key={series.title}>
              <Button
                className={classNames(isActive && 'font-bold py-0')}
                onClick={(e: MouseEvent<HTMLButtonElement>) => {
                  e.preventDefault();
                  setFilters({ filterName: series.filter, filterType });
                }}
                variant={ButtonVariant.bare}
                size="small"
                aria-current={isActive ? 'true' : 'false'}
              >
                <CheckIcon
                  color="currentColor"
                  decorative
                  title={`Check-${series.title}-${index}`}
                  className={classNames('mr-1', isActive ? 'opacity-100' : 'opacity-0')}
                />
                {series.title}
                {typeof series.count === 'number' && (
                  <span className="text-neutral-500 ml-1">({series.count})</span>
                )}
              </Button>
            </li>
          );
        })}
      </ul>
    </BaseAccordion>
  );
};

export default FilterAccordion;
